<template>
  <v-card class="project-chat-card">
    <v-card-title class="pb-2">
      Czat projektowy
      <div
        v-if="unread"
        class="project-chat-card__details"
      >
        <v-icon color="primary">
          mdi-email-outline
        </v-icon>
      </div>
    </v-card-title>

    <v-card-text class="project-chat-card__content">
      <template v-if="chat.messages.length">
        <div
          v-for="(message, i) in messagesToDisplay"
          :key="i"
          class="py-3"
        >
          <div class="d-flex flex-row align-center mb-2">
            <AppAvatar :user="message" />
            <div class="d-flex flex-column ml-4">
              <p class="text-subtitle-2">
                {{ message | fullName }}
              </p>
              <p class="text-10">
                {{ message.createdAt | dateWithTime }}
              </p>
            </div>
          </div>

          <p class="caption">
            {{ message.text }}
          </p>
        </div>
      </template>

      <AppEmptyState
        v-else
        title="Brak wiadomości"
        subtitle="W projekcie nie została dodana jeszcze żadna wiadomość."
      />
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn
        v-if="chat.id"
        text
        link
        small
        color="primary"
        :to="{ name: 'project-chat-channel', params: { projectId, channelId: chat.id } }"
      >
        Czat projektowy
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AppAvatar from '@/components/UI/AppAvatar.vue';
import AppEmptyState from '@/components/UI/AppEmptyState.vue';

export default {
  components: {
    AppAvatar,
    AppEmptyState,
  },

  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    chat: {
      type: Object,
      required: true,
    },
    unread: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    messagesToDisplay() {
      return this.chat.messages.slice(0, 2);
    },
  },
};
</script>

<style lang="scss" scoped>
.project-chat-card {
  min-height: 350px;

  &__content {
    min-height: calc(350px - 102px);
    display: flex;
    flex-direction: column;
  }
}
</style>
